import { SAVE_AUTHORIZATION, CLEAR_AUTHORIZATION } from './action-types';

export const saveAuthorization = (token, role) => {
  return {
    type: SAVE_AUTHORIZATION,
    token: token,
    role: role,
  };
};

export const clearAuthorization = () => {
  return {
    type: CLEAR_AUTHORIZATION,
  };
};



// WEBPACK FOOTER //
// ./src/actions/authorization-actions.js